<template>
  <a-card :bordered="true">
    <p v-if="!showPage">功能未开通</p>
    <!-- 表格内容操作 start -->
    <!-- <div class="table-operator">
      <a-button type="primary" style="margin-right:15px;">全部导出</a-button>
      <a-button type="dashed" @click="toggleTableAlert()">{{ optionAlertShow && '关闭' || '开启' }}多选</a-button>
      <a-dropdown v-if="optionAlertShow && selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1"><a-icon type="file-zip" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
      <a-radio-group style="float:right" v-model="queryParam.status" @change="handleSubmit">
        <a-radio-button v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
      </a-radio-group>
    </div> -->
    <!-- 表格内容操作 end -->
    <a-tabs v-if="showPage" default-active-key="1">
      <a-tab-pane key="1" tab="待上课">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit1">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="上课日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker :default-value="[moment(queryParam1.startTime, dateFormat), moment(queryParam1.endTime, dateFormat)]"  @change="onDateChange" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">刷新</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-15px;"
          :scroll="{ x: 2500 }"
          ref="table1"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData1"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="student" slot-scope="text, record">
            {{ record.student_data.english_name }}
          </span>
          <span slot="class_demand" slot-scope="text, record">
            {{ record.student_data.requirement }}
          </span>
          <span slot="kyjc" slot-scope="text, record">
            {{ record.student_data.kyjc }}
          </span>
          <span slot="kymb" slot-scope="text, record">
            {{ record.student_data.kymb }}
          </span>
          <span slot="oetime" slot-scope="text, record">
            {{ record.student_data.oetime }}
          </span>
          <span slot="times" slot-scope="text, record">
            <span v-if="record.ctype === '菲教'">{{ record.class_time || '--' }}-{{ record.end_time }}</span>
            <span v-if="record.ctype !== '菲教'">{{ record.times || '--' }}</span>
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.student_data.qq }}
          </span>
          <template slot="meeting_number" slot-scope="text, record">
            {{ text }} <a-icon @click="showEditMn(record)" type="edit" />
          </template>
          <span slot="report" slot-scope="text, record">
            <a v-if="record.report" :href="record.report">下载</a>
            <span v-if="!record.report">--</span>
          </span>
          <span slot="kjpath" slot-scope="text, record">
            <a v-if="record.kjpath" :href="record.kjpath">{{ record.ware_title || '课件' }}</a>
            <span v-if="!record.kjpath">--</span>
          </span>
          <span slot="status">
            未上课
          </span>
          <span slot="topic_progress" slot-scope="text, record">
            <a @click="showProgress(record)" title="点击查看学习进度">点击查看</a>
          </span>
          <span slot="topic" slot-scope="text, record">
            <p style="line-height:100%;" v-for="(topic, index) in record.topic" :key="index">{{ topic.p_title }}:{{topic.title}}</p>
          </span>
          <span slot="action">
            --
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
      <a-tab-pane key="2" tab="未上传">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit2">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">刷新</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-15px;"
          :scroll="{ x: 2500 }"
          ref="table2"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData2"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="student" slot-scope="text, record">
            {{ record.student_data.english_name }}
          </span>
          <span slot="class_demand" slot-scope="text, record">
            {{ record.student_data.requirement }}
          </span>
          <span slot="kyjc" slot-scope="text, record">
            {{ record.student_data.kyjc }}
          </span>
          <span slot="kymb" slot-scope="text, record">
            {{ record.student_data.kymb }}
          </span>
          <span slot="oetime" slot-scope="text, record">
            {{ record.student_data.oetime }}
          </span>
          <span slot="times" slot-scope="text, record">
            <span v-if="record.ctype === '菲教'">{{ record.class_time || '--' }}-{{ record.end_time }}</span>
            <span v-if="record.ctype !== '菲教'">{{ record.times || '--' }}</span>
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.student_data.qq }}
          </span>
          <template slot="meeting_number" slot-scope="text, record">
            {{ text }} <a-icon @click="showEditMn(record)" type="edit" />
          </template>
          <span slot="status">
            未上传
          </span>
          <span slot="topic_progress" slot-scope="text, record">
            <a @click="showProgress(record)" title="点击查看学习进度">点击查看</a>
          </span>
          <span slot="topic" slot-scope="text, record">
            <p style="line-height:100%;" v-for="(topic, index) in record.topic" :key="index">{{ topic.p_title }}:{{topic.title}}</p>
          </span>
          <span slot="report" slot-scope="text, record">
            <a v-if="record.report" :href="record.report">下载</a>
            <span v-if="!record.report">--</span>
          </span>
          <span slot="kjpath" slot-scope="text, record">
            <a v-if="record.kjpath" :href="record.kjpath">{{ record.ware_title }}</a>
            <span v-if="!record.kjpath">--</span>
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="showReportModal(record)">上传报告</a>
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
      <a-tab-pane key="3" tab="已完成">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit3">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">刷新</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-15px;"
          :scroll="{ x: 2500 }"
          ref="table3"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData3"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="student" slot-scope="text, record">
            {{ record.student_data.english_name }}
          </span>
          <span slot="class_demand" slot-scope="text, record">
            {{ record.student_data.requirement }}
          </span>
          <span slot="kyjc" slot-scope="text, record">
            {{ record.student_data.kyjc }}
          </span>
          <span slot="kymb" slot-scope="text, record">
            {{ record.student_data.kymb }}
          </span>
          <span slot="oetime" slot-scope="text, record">
            {{ record.student_data.oetime }}
          </span>
          <span slot="times" slot-scope="text, record">
            <span v-if="record.ctype === '菲教'">{{ record.class_time || '--' }}-{{ record.end_time }}</span>
            <span v-if="record.ctype !== '菲教'">{{ record.times || '--' }}</span>
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.student_data.qq }}
          </span>
          <template slot="meeting_number" slot-scope="text, record">
            {{ text }} <a-icon @click="showEditMn(record)" type="edit" />
          </template>
          <span slot="status">
            已完成
          </span>
          <span slot="topic_progress" slot-scope="text, record">
            <a @click="showProgress(record)" title="点击查看学习进度">点击查看</a>
          </span>
          <span slot="topic" slot-scope="text, record">
            <p style="line-height:100%;" v-for="(topic, index) in record.topic" :key="index">{{ topic.p_title }}:{{topic.title}}</p>
          </span>
          <span slot="report" slot-scope="text, record">
            <a v-if="record.report" :href="record.report">下载</a>
            <span v-if="!record.report">--</span>
          </span>
          <span slot="kjpath" slot-scope="text, record">
            <a v-if="record.kjpath" :href="record.kjpath">{{ record.ware_title }}</a>
            <span v-if="!record.kjpath">--</span>
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="showReportModal(record)">上传报告</a>
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
      <a-tab-pane key="4" tab="已取消">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit4">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">刷新</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-15px;"
          :scroll="{ x: 2500 }"
          ref="table4"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData4"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="student" slot-scope="text, record">
            {{ record.student_data.english_name }}
          </span>
          <span slot="kyjc" slot-scope="text, record">
            {{ record.student_data.kyjc }}
          </span>
          <span slot="kymb" slot-scope="text, record">
            {{ record.student_data.kymb }}
          </span>
          <span slot="oetime" slot-scope="text, record">
            {{ record.student_data.oetime }}
          </span>
          <span slot="times" slot-scope="text, record">
            <span v-if="record.ctype === '菲教'">{{ record.class_time || '--' }}-{{ record.end_time }}</span>
            <span v-if="record.ctype !== '菲教'">{{ record.times || '--' }}</span>
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.student_data.qq }}
          </span>
          <span slot="meeting_number" slot-scope="text, record">
            {{ text }} <a-icon @click="showEditMn(record)" type="edit" />
          </span>
          <span slot="status">
            已取消
          </span>
          <span slot="topic_progress" slot-scope="text, record">
            <a @click="showProgress(record)" title="点击查看学习进度">点击查看</a>
          </span>
          <span slot="report" slot-scope="text, record">
            <a v-if="record.report" :href="record.report">下载</a>
            <span v-if="!record.report">--</span>
          </span>
          <span slot="topic" slot-scope="text, record">
            <p style="line-height:100%;" v-for="(topic, index) in record.topic" :key="index">{{ topic.p_title }}:{{topic.title}}</p>
          </span>
          <span slot="kjpath" slot-scope="text, record">
            <a v-if="record.kjpath" :href="record.kjpath">{{ record.ware_title }}</a>
            <span v-if="!record.kjpath">--</span>
          </span>
          <span slot="action">
            --
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
    </a-tabs>
    <a-modal :confirm-loading="confirmLoading" v-if="editMnVisible" :visible="editMnVisible" title="会议号更新" @ok="handleMnOk" @cancel="editMnVisible = false">
      <a-input v-model="editMnData.meeting_number" placeholder="请输入会议号" />
    </a-modal>
    <a-modal :confirm-loading="confirmLoading" v-if="reportVisible" :visible="reportVisible" title="上传报告" @ok="handleReportOk" @cancel="reportVisible = false">
      <a-upload
        name="file"
        :multiple="false"
        list-type="text"
        action="/teacher.php/upload_file/uploadFile?type=report"
        @change="handleReportChange"
      >
        <a-button><a-icon type="upload" />点击上传报告</a-button>
      </a-upload>
      <br />
      选择话题：<a-select
          style="width:400px;"
          mode="multiple"
          v-model="reportData.topic"
          placeholder="请选择话题，可多选">
          <a-select-option v-if="item.type === 'TOPIC' && item.pid !== 0" v-for="item in wareDict" :key="item.detail_id" :value="item.title">{{ item.pid | valInDict(topicDict) }} : {{ item.title }}</a-select-option>
        </a-select>
      <br />
      <span>If it is a IELTS speaking class, pls choose the topics which are practiced in the class.</span>
      <br />
    </a-modal>
    <!-- 学习进度 -->
    <a-modal v-if="progressVisible" :visible="progressVisible" title="学习进度" @ok="progressVisible=false" @cancel="progressVisible = false">
      <p style="font-size:16px;font-weight:bold;">课程名称：{{ nowCname }}</p> 
      <div v-for="(topic, index) in progressData.detailList" :key="index" style="margin-top:20px;">
        <span style="font-size:16px;">{{ topic.pid | valInDict(topicDict)  }}</span> : <span>{{ topic.title }}</span><span v-if="topic.is_new==='YES'" style="color:red;">（NEW）</span><span v-if="topic.checked==='NO'" style="color:red;">（待学习）</span><span v-if="topic.checked==='YES'" style="color:yellow">（已上课）</span>
        <span v-for="(time, i) in topic.times" :key="i">
          <a-icon type="check-circle" style="font-size:14px;color:yellow;margin-left:20px;"/><span style="margin-left:10px;font-size:12px;">{{ time }}</span>
        </span>
      </div>
    </a-modal>
  </a-card>
</template>
<script>
import moment from 'moment'
import { getPre, getList, saveMn, saveReport, checkProgress } from '@/api/subscribe'
import { getDetailList } from '@/api/material'
import { getUserInfo } from '@/api/account'
import { TcgTable } from '@/components'
import notification from 'ant-design-vue/es/notification'
import _ from 'lodash'

const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" style="width:90%;" @pressEnter="check"/><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String,
  },
  data() {
    return {
      value: this.text,
      editable: false,
    };
  },
  methods: {
    handleChange(e) {
      const value = e.target.value;
      this.value = value;
    },
    check() {
      this.editable = false;
      this.$emit('change', this.value);
    },
    edit() {
      this.editable = true;
    },
  },
}
export default {
  components: {
    TcgTable,
    EditableCell
  },
  data () {
    this.dateFormat = 'YYYY-MM-DD'
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      // 时间
      time: [],
      // 查看抽屉状态开关
      viewVisible: false,
      // id
      id: '',
      // 字典
      dict: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam1: {
        status: 'WAIT',
        startTime: moment().format("YYYY-MM-DD"),
        endTime: moment().format("YYYY-MM-DD")
      },
      queryParam2: {
        status: 'UNLOAD'
      },
      queryParam3: {
        status: 'DONE'
      },
      queryParam4: {
        status: 'CANCEL'
      },
      // 表头
      columns: [
        {
          title: '日期',
          dataIndex: 'days',
          sorter: true
        },
        {
          title: '时间',
          dataIndex: 'times',
          scopedSlots: { customRender: 'times' },
          sorter: true
        },
        {
          title: '旺旺名',
          dataIndex: 'uname'
        },
        {
          title: '课程名称',
          dataIndex: 'cname',
          scopedSlots: { customRender: 'cname' }
        },
        {
          title: '学生',
          dataIndex: 'student',
          scopedSlots: { customRender: 'student' }
        },
        {
          title: '口语基础',
          dataIndex: 'kyjc',
          scopedSlots: { customRender: 'kyjc' }
        },
        {
          title: '口语目标',
          dataIndex: 'kymb',
          scopedSlots: { customRender: 'kymb' }
        },
        {
          title: '考试日期',
          dataIndex: 'oetime',
          scopedSlots: { customRender: 'oetime' }
        },
        {
          title: '联系方式',
          dataIndex: 'qq',
          scopedSlots: { customRender: 'qq' }
        },
        {
          title: '上课要求',
          dataIndex: 'class_demand',
          scopedSlots: { customRender: 'class_demand' }
        },
        {
          title: '会议号',
          dataIndex: 'meeting_number',
          scopedSlots: { customRender: 'meeting_number' }
        },
        {
          title: '话题进度',
          dataIndex: 'topic_progress',
          scopedSlots: { customRender: 'topic_progress' }
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '话题',
          dataIndex: 'topic',
          scopedSlots: { customRender: 'topic' }
        },
        {
          title: '课件',
          dataIndex: 'kjpath',
          scopedSlots: { customRender: 'kjpath' }
        },
        {
          title: '报告',
          dataIndex: 'report',
          scopedSlots: { customRender: 'report' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'sub_id',
          key: 'action',
          width: '100px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData1: parameter => {
        return getList(Object.assign(parameter, this.queryParam1))
          .then(res => {
            return res
          })
      },
      loadData2: parameter => {
        return getList(Object.assign(parameter, this.queryParam2))
          .then(res => {
            return res
          })
      },
      loadData3: parameter => {
        return getList(Object.assign(parameter, this.queryParam3))
          .then(res => {
            return res
          })
      },
      loadData4: parameter => {
        return getList(Object.assign(parameter, this.queryParam4))
          .then(res => {
            return res
          })
      },
      editMnVisible: false,
      editMnData: {},
      confirmLoading: false,
      reportVisible: false,
      reportData: {
        sub_id: 0,
        report: '',
        topic: []
      },
      showPage: true,
      wareDict: [],
      nowCname: '',
      progressVisible: false,
      progressData: {
        detailList: [],
        progressList: []
      },
      topicDict: []
    }
  },
  created () {
    this.handelPre()
  },
  methods: {
    handelPre () {
      // 获取用户信息
      getUserInfo().then(response => {
        const classifcation = _.get(response, 'data.classifcation', [])
        console.log(classifcation)
        const fj= classifcation.findIndex(item => item=== '菲教')
        const om= classifcation.findIndex(item => item=== '欧美外教')
        if (fj === -1 && om === -1) {
          this.showPage = false
        }
      })
    },
    moment,
    showEditMn (record) {
      this.editMnVisible = true
      this.editMnData = {
        sub_id: record.sub_id,
        meeting_number: record.meeting_number
      }
    },
    onCellChange(key, dataIndex, value) {
      if (dataIndex === 'meeting_number'){
        this.handleMnOk({ sub_id: key, meeting_number: value })
      }
    },
    handleMnOk () {
      this.confirmLoading = true
      saveMn(this.editMnData).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$refs.table1.refresh(true)
          this.confirmLoading = false
          this.editMnVisible = false
          this.$message.success('更新成功')
        } else {
          this.confirmLoading = false
          this.$message.error('更新失败')
        }
      })
    },
    onDateChange(date, dateString) {
      console.log(dateString)
      this.queryParam1.startTime=dateString[0]
      this.queryParam1.endTime=dateString[1]
      this.$refs.table1.refresh(true)
    },
    showReportModal (record) {
      getDetailList({ mat_id: record.mat_id, order_id: record.order_id, size: 1000, type: 'TOPIC', order_by: 'pid ASC, detail_id DESC' }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.wareDict = _.get(res, 'data', [])
          this.topicDict = _.get(res, 'values.topicDict', [])
        }
      })
      let topicArr = []
      const topic = record.topic
      topic.forEach((item) => {
        topicArr.push(item.title)
      })
      this.reportData.topic = topicArr
      this.reportData.sub_id = record.sub_id
      this.reportData.report = ''
      this.reportVisible = true
    },
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.data[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} 上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const path = _.get(info.file, 'response.data.path')
        const fileUrl = _.get(info.file, 'response.data.url')
        this.reportData.report = path
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    handleReportChange (info) {
      this.handleFileUpload(info, 'report')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    handleReportOk () {
      if (this.reportData.report === '') {
        this.$message.warning('请上传报告')
        return false
      }
      this.confirmLoading = true
      saveReport(this.reportData).then(res => {
        if (_.get(res, 'code') === 200) {
          this.confirmLoading = false
          this.$refs.table2.refresh(true)
          this.$refs.table3.refresh(true)
          this.reportVisible = false
          notification.success({
            message: '更新成功',
            description: '保存成功'
          })
        } else {
          this.confirmLoading = false
          notification.warning({
            message: '更新失败',
            description: '请稍后再试'
          })
        }
      })
    },
    // 开启更多查询方式
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 重置按钮
    reset () {
      this.queryParam = {
        status: ''
      }
    },
    // 关闭查看按钮事件
    cancelViewDrawer () {
      this.viewVisible = false
    },
    // 打开查看抽屉
    openViewModal (id) {
      this.id = id
      this.viewVisible = true
    },
    // 在查看抽屉中完成编辑
    finishViewAndEdit () {
      this.$refs.table.refresh(true)
    },
    // 提交筛选
    handleSubmit1 (e) {
      e.preventDefault()
      this.$refs.table1.refresh(true)
    },
    handleSubmit2 (e) {
      e.preventDefault()
      this.$refs.table2.refresh(true)
    },
    handleSubmit3 (e) {
      e.preventDefault()
      this.$refs.table3.refresh(true)
    },
    handleSubmit4 (e) {
      e.preventDefault()
      this.$refs.table4.refresh(true)
    },
    // 切换提示
    toggleTableAlert () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    // 表格选择
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 批量操作按钮事件
    handleMenuClick (e) {
      if (e.key === '1') {
        const arrImages = []
        for (const i in this.selectedRows) {
        }
      }
    },
    showProgress (record) {
      this.nowCname = record.cname
      // 查询学习进度
      checkProgress({ sub_id: record.sub_id }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.progressData = _.get(res, 'data', {})
          this.topicDict = _.get(res, 'values.topicDict', [])
        }
      })
      this.progressVisible = true
    }
  }
}
</script>
<style lang="less" scoped>
.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}
</style>
